<template>
  <div class="relative flex items-center">
    <div class="flex h-5 items-center">
      <input
        :value="true"
        :name="name"
        type="checkbox"
        class="size-6 rounded border-background-fg/30 text-primary focus:ring-primary"
        :checked="modelValue"
        @change="onChange"
      />
    </div>
    <div class="ml-3 text-sm">
      <label
        :for="name"
        class="font-medium text-background-fg/70"
      >
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean
  label?: string
  name: string
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const onChange = (event: Event) => {
  emit(
    "update:modelValue",
    (event.target as HTMLInputElement).checked
  )
}
</script>
